<template>
  <div class="product-families-index-view">
    <h1>
      {{$t('titles.index')}}
      <span v-if="category">
        in
        <router-link
          :title="categoryTitle"
          :to="{ name: 'product-category', params: { id: categoryId } }"
        >{{category.name}}</router-link>
      </span>
    </h1>

    <link-button
      :to="{ name: 'new-standard-product-family' }"
      icon="plus"
      type="primary"
    >{{$t('actions.newStandard')}}</link-button>

    <link-button
      :to="{ name: 'new-bundle-product-family' }"
      icon="plus"
    >{{$t('actions.newBundle')}}</link-button>

    <search-input class="uk-align-right" ref="search" v-model="searchQuery" />

    <data-grid
      :columns="gridColumns"
      :is-loading="isLoading"
      :page-info="productFamilies.pagination"
      :rows="productFamilies.entries"
      :sort-info="productFamilies.sort"
      :sortable="['name']"
      @sort="sortBy"
      class="uk-margin-medium"
      v-if="gridLoaded"
    >
      <span slot="empty">{{$t('hints.empty')}}</span>
      <template scope="props" slot="row">
        <td>
          <router-link
            :to="{
              name: 'product-family',
              params: { id: props.row.id }
            }"
          >{{props.row.name}}</router-link>
        </td>
        <td>
          <article-number :value="props.row.familyNumber" v-if="props.row.familyNumber" />
          <text-placeholder v-else />
        </td>
        <td>
          <product-type :bundle="props.row.bundle" />
        </td>
        <td>
          <timeago :auto-update="60" :since="props.row.updatedAt" />
        </td>
        <td>
          <data-grid-actions
            :edit-route="{ name: 'edit-product-family',
                           params: { id: props.row.id } }"
            @remove="deleteRecordWhenConfirmed(props.row)"
          >
            <li>
              <router-link
                :to="{ name: 'product-family-revisions',
                       params: { id: props.row.id } }"
              >
                <icon name="future" />
              </router-link>
            </li>
          </data-grid-actions>
        </td>
      </template>
    </data-grid>

    <div
      class="loader-container uk-container uk-margin-medium-top uk-text-center"
      v-else
    >
      <loader />
    </div>
  </div>
</template>

<script>
import { parseInt } from 'lodash';
import ArticleNumber from '@/components/ArticleNumber';
import deleteProductFamilyMutation
  from '@/api/mutations/delete-product-family.graphql';
import IndexView from '@/mixins/IndexView';
import productCategoryQuery from '@/api/queries/product-category.graphql';
import productFamiliesQuery from '@/api/queries/product-families.graphql';
import ProductType from '@/components/ProductType';
import TextPlaceholder from '@/components/TextPlaceholder';
import Yes from '@/components/Yes';

export default {
  name: 'product-families-index-view',
  mixins: [
    IndexView('productFamilies', {
      gridFields: ['name', 'familyNumber', 'type', 'updatedAt'],
      listQuery: productFamiliesQuery,
      deleteMutation: deleteProductFamilyMutation,
      nameField: 'name',
      defaultFilter() {
        const filter = {};
        if (this.categoryId) {
          filter.categoryIds = [this.categoryId];
        }
        return filter;
      },
    }),
  ],
  components: {
    ArticleNumber,
    ProductType,
    TextPlaceholder,
    Yes,
  },
  computed: {
    categoryId() {
      const categoryId = parseInt(this.$route.query.categoryId);
      if (isNaN(categoryId)) return null;
      return categoryId;
    },
    categoryTitle() {
      return `${this.category.name} (${this.category.tenant.name})`;
    },
  },
  apollo: {
    category: {
      query: productCategoryQuery,
      variables() {
        return { id: this.categoryId };
      },
      fetchPolicy: 'network-only',
      loadingKey: 'loading',
      update({ productCategory }) {
        return productCategory;
      },
      skip() {
        return !this.isAuthenticated || !this.categoryId;
      },
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          newStandard: 'Produktfamilie erstellen',
          newBundle: 'Bundlefamilie erstellen',
        },
        hints: {
          empty: 'Keine Produktfamilien gefunden.',
        },
        confirmations: {
          delete: `Produktfamilie <strong>{name}</strong> wirklich löschen?
                   Alle zugehörigen Produkte, Bilder und Angebote werden
                   ebenfalls gelöscht.`,
        },
        titles: {
          index: 'Produktfamilien',
        },
        toasts: {
          deleted: 'Produktfamilie gelöscht: {name}',
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.product-families-index-view__thumbnail-cell {
  width: 44px;
}
</style>



// WEBPACK FOOTER //
// IndexView.vue?c15a2784